import React from 'react';
import {QueueOptions} from "./enums/queueOptions";
import {useIntegrationDispatch, useIntegrationStore} from "../../integration-store";

const integrationLabels: {[key: string]: string} = {
  [QueueOptions.BfitArchive]: 'BFIT Archive',
  [QueueOptions.DataWarehouse]: 'Data Warehouse Archive',
  [QueueOptions.WorkdaySupplierDomestic]: 'Workday Supplier - Domestic',
  [QueueOptions.WorkdaySupplierForeign]: 'Workday Supplier - Foreign'
}

const VALID_QUEUE_VALUES = new Set<string>(Object.values(QueueOptions));

const IntegrationQueues = () => {
  const dispatch = useIntegrationDispatch();
  const {integrationQueues} = useIntegrationStore();

  // Coerce any retired or unknown queue value to '' so the select deterministically
  // shows "None" rather than rendering a blank/unmatched option.
  const selectedQueue = VALID_QUEUE_VALUES.has(integrationQueues[0]) ? integrationQueues[0] : '';

  const handleQueueChange = (queue: string) => {
    dispatch({type: 'setIntegrationQueues', payload: {
      integrationQueues: [queue]
    }});
  }

  return (
      <div className={'form-group'}>
        <label htmlFor="external-system">Send to External System:</label>
        <select
          id="external-system"
          style={{background: "#fff"}}
          value={selectedQueue}
          onChange={(event) => handleQueueChange(event.target.value)}
        >
          <option value={''}>None</option>
          {Object.keys(integrationLabels).map(integrationKey => {
            return <option key={'option-'+integrationKey} value={integrationKey}>{integrationLabels[integrationKey]}</option>
          })}
        </select>
      </div>
  );
}

export { IntegrationQueues };